import Footer from "../Footer/Footer";
import SimpleHeader from "../NewApp/SimpleHeader";
import FAQSection, { FAQItem } from "../reusable/FAQ/FAQ";
import Plan from "../reusable/Plan/Plan";
import "./GetOutOfDebt.css";

const faqData: FAQItem[] = [
  {
    question: "Ինչպե՞ս սկսել պարտքերի վճարումը, եթե ունեմ մի քանի տարբեր պարտքեր։",
    answer: "Պետք է նախ կազմել պարտքերի ցուցակ՝ ըստ տոկոսադրույքի կամ մնացորդի։ Կարող եք ընտրել «ավալանշ» մեթոդը (վճարել ամենաբարձր տոկոսադրույքով պարտքը առաջինը) կամ «ձնագնդի» մեթոդը (վճարել ամենափոքր պարտքը առաջինը)։ Այս մեթոդները կօգնեն արագ նվազեցնել պարտքերի ընդհանուր գումարը։",
  },
  {
    question: "Կարո՞ղ եմ վերաֆինանսավորել իմ վարկը ավելի ցածր տոկոսադրույքով։",
    answer: "Այո, Հայաստանում շատ բանկեր առաջարկում են վարկերի վերաֆինանսավորում։ Այսինքն՝ կարող եք տեղափոխել ձեր վարկը մեկ այլ բանկ՝ ավելի լավ պայմաններով և ցածր տոկոսադրույքով։",
  },
  {
    question: "Ի՞նչ կլինի, եթե չկարողանամ վճարել պարտքս ժամանակին։",
    answer: "Եթե ուշացնեք վճարումները, կարող եք ենթարկվել տուգանքների, կուտակել տոկոսներ, և ձեր վարկային պատմությունը կարող է վատանալ։ Եթե երկար ժամանակ չվճարեք, վարկատուն կարող է դիմել դատական կարգով պարտքը վերադարձնելու համար։",
  },
  {
    question: "Ինչպե՞ս իմանալ, թե որ պարտքերն է պետք առաջինը վճարել։",
    answer: "Առաջին հերթին վճարեք այն պարտքերը, որոնք ունեն ամենաբարձր տոկոսադրույքը կամ ամենախիստ պայմանները։ Սա կօգնի նվազեցնել ընդհանուր վճարվող գումարը ժամանակի ընթացքում։",
  },
  {
    question: "Կարո՞ղ եմ բանակցել վարկատուի հետ տոկոսադրույքը նվազեցնելու համար։",
    answer: "Այո, հաճախ կարելի է զանգահարել վարկատուին և խնդրել նվազեցնել տոկոսադրույքը, հատկապես եթե ունեք լավ վարկային պատմություն կամ պատրաստվում եք տեղափոխել վարկը այլ բանկ։",
  },
];

const GetOutOfDebt: React.FC = () => (
  <div className="get-out-of-debt-wrapper">
    <SimpleHeader onHome={() => window.location.href = '/'} onResources={() => window.location.href = '/resources'} />
    <div className="get-out-of-debt-background">
      <div className="gradient-blob blob-1"></div>
      <div className="gradient-blob blob-2"></div>
    </div>
    <Plan
      steps={[
        {
          title: "Ազատվել մեղքի և ամոթի զգացումից",
          text: "Շատ հաճախ մենք ամաչում ենք մեր ծախսային սովորություններից, ու խուսափում ենք դրանցից՝ մեզ դնելով վատ իրավիճակի մեջ։ Մի ուսին՝ հրեշտակն ասում է՝ «Մի գնիր դա, այդ գումարը ուղղիր պարտքիդ», իսկ մյուս ուսին՝ սատանան ասում է՝ «Վերցրու, դու արժանի ես դրան»։ Մեզանից շատերն երբեք ֆինանսական կրթություն չեն ստացել, չեն խոսել դրա մասին, որովհետև այս թեման համարվում է տաբու։ Հետեւաբար, հենց ներողամտության այս դիրքից կարող եք պատրաստ լինել վերջնականապես լուծելու Ձեր պարտքերը։",
        },
        {
          title: "Ավտոմատացնել վճարումներն ու խնայողությունները",
          text: "Եթե Դուք չունեք ապահովության ֆոնդ (3-6 ամսվա պարտադիր ծախսերի գումար), շատ կարևոր է, որ սկսեք ձևավորել այն։ Կարող եք որոշ ժամանակ վճարել պարտքերի մինիմումներն ու ձևավորել ֆոնդը։ Բոլորիս կյանքում լինում են վատ օրեր և ֆոնդը կօգնի, որ նոր պարտքեր չկուտակեք։ Դրանից հետո պետք է ուղղել յուրաքանչյուր ավելորդ դրամը դեպի պարտքերի մարումը։ Սա կարևոր է, քանի որ Հայաստանում վարկերի տոկոսները առողջ չեն։ Պարտքը մարելու հաճելի կամ հեշտ տարբերակ չկա՝ միայն քրտնաջան աշխատանք և վճռականություն։",
        },
        {
          title: "Կատարել փոքր ֆինանսական փոփոխություններ",
          text: "Դժվար աշխատանքն անխուսափելի է, բայց փոքր քայլերն էլ մեծ ազդեցություն կարող են ունենալ։ Օրինակ՝ կարող եք զանգահարել բանկին և խնդրել իջեցնել տոկոսադրույքը՝ նշելով, որ դժվարանում եք կատարել վճարումներն և մտածում եք ավելի ցածր տոկոսադրույքով բանկ տեղափոխելու մասին, եթե չկարողանան օգնել։ Նրանք ցանկանում են Ձեզ պահել որպես տոկոս վճարող հաճախորդ։ Կզարմանաք, թե որքան պատրաստակամ են լինում աջակցել։",
        },
        {
          title: "Հասկանալ, որ հեշտ է ծախսել",
          text: "Եթե խնայելու պլան և համակարգ չենք ունենում, հեշտ է լինում ընկնել թրենդների ետևից։ Ամբողջ աշխարհը փող է աշխատում՝ ազդելով մարդկանց հոգեբանության վրա։ Պետք է հասկանալ, որ մեզ վրա միշտ ազդելու են։",
        },
        {
          title: "Ընտրել պարտքերի մարման մեթոդ՝ ձնագնդի կամ ավալանշ",
          text: "Միլիոնավոր ձևեր կան պարտքերի մարման։ Ամենահայտնիներից են՝ ձնագնդի և ավալանշի մեթոդը։ Ձնագնդի մեթոդով՝ դուք առաջինը փակում եք փոքր պարտքերը, որոնք ստեղծում են արագացում՝ թողնելով մեծերը։ Ավալանշի մեթոդով՝ դուք սկսում եք ամենամեծ պարտքից։",
        }
      ]}
      mainTitle={"Պարտքը ապագայից խլված բարեկեցությունն է"}
      intro={"Եթե դուք այս էջում եք, ինչ-որ մի բան մի տեղ, հնարավոր է, սխալ է գնացել։ Հայաստանում տնային պարտքը 2025 թվականի հունվարին հասել է 7.9 միլիարդ ԱՄՆ դոլարի։ Դուք միակը չեք նման կարգավիճակում։ Ահնար է կապիտալ ձևավորել եթե դուք կուտակում եք պարտքեր։ Սովորեք ինչպես ազատվել պարտքերից՝ ավելի բարեկեցիկ ապագայի համար։"}
    ></Plan>
    <Plan
      steps={[
        {
          title: "«Առանց ավելորդ ծախսի» ամիսներ",
          text: "Ես սիրում եմ ունենալ «Առանց ավելորդ ծախսի» ամիսներ։ Տարվա սկզբին որոշում եմ, որ օրինակ Ապրիլը և Հոկտեմբերը լինելու են «առանց ավելորդ ծախսի» ամիսներ։ Ըստ այդմ չեմ կատարում ոչ մի ավելորդ ծախսեր այդ ամիսներին։",
        },
        {
          title: "Շաբաթ-Կիրակիների մասին",
          text: "Շաբաթ-կիրակիները նրանց համար են, ովքեր ունեն ծախսելու փող։ Ես վերաբերվում եմ այդ երկու օրվան՝ որպես իմ վրա աշխատելու օրեր։ Այս բլոգը այստեղ չէր լինի եթե ես ինձ տայի շաբաթ-կիրակի ծախսելու փող։",
        },
        {
          title: "Ավտոմատացում",
          text: "Ես ավտոմատացրել եմ համարյա ամեն ինչ իմ կյանքում։ Երբ աշխատավարձ եմ ստանում՝ առաջինը վճարում եմ ինձ (խնայում եմ մի մասը), ապա՝ իմ տան վարձն ու կոմունալները։ Մի մասը պահում եմ պարտադիր ծախսերի համար, մյուսով՝ զվարճանում եմ։ Կարևորը՝ առաջինը՝ ինձ։",
        }
      ]}
      mainTitle={"Բոնուսային կետեր"}
      intro={""}
    ></Plan>
    <div>
      <FAQSection faqs={faqData} />
    </div>
    <Footer></Footer>
  </div>
);

export default GetOutOfDebt;
